export const typeMaps = [
    {
      typeCode: '1',
      typeValue: '自营',
    },
    {
      typeCode: '2',
      typeValue: '三方',
    }
  ]